import React, { PureComponent, Fragment } from 'react'
import { localize } from 'helpers/translator'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'
import { BaseButton } from 'components/button'

import styles from './share_link_box.scss'

class ShareLinkBox extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			color: 'blue',
			text: localize('btn_copy_text'),
		}
		this.ref = React.createRef()
	}

	handleSelectButton = () => {
		this.setState({
			text: localize('btn_copy_text_copied'),
			color: 'green',
		})
		this.copyToClipboard()
		this.props.onSelect()
	}

	copyToClipboard = () => {
		this.ref.current.select()
		this.ref.current.focus()
		document.execCommand('copy')
	}

	render() {
		const { linkLabel, shouldShowSeparator, url } = this.props
		return (
			<Fragment>
				{linkLabel &&
					<label>
						<span styleName='link-label-bold'>{linkLabel}</span> {localize('lesson_link')}
					</label>
				}
				<div styleName='link-section'>
					<textarea
						styleName='link-section-text'
						ref={this.ref}
						defaultValue={url}
						readOnly
					/>
					<div styleName='link-section-btn-container'>
						<BaseButton
							bgColor={this.state.color}
							fontColor='white'
							onClick={this.handleSelectButton}
						>
							{this.state.text}
						</BaseButton>
					</div>
				</div>
				{shouldShowSeparator &&
					<div styleName='link-separator'></div>
				}
			</Fragment>
		)
	}
}

ShareLinkBox.defaultProps = {
	onSelect: () => {},
}

ShareLinkBox.propTypes = {
	linkLabel: PropTypes.string.isRequired,
	shouldShowSeparator: PropTypes.bool.isRequired,
	url: PropTypes.string.isRequired,
	onSelect: PropTypes.func,
}

export default CSSModules(ShareLinkBox, styles, {allowMultiple: true})
